/**
 * Utility functions for handling links safely
 */

/**
 * Opens external links safely in a new tab with security measures
 */
export const openExternalLink = (url: string): void => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) {
    newWindow.opener = null; // Additional security measure
  }
};

/**
 * Validates if a URL is external (not same origin)
 */
export const isExternalLink = (url: string): boolean => {
  try {
    const urlObj = new URL(url, window.location.origin);
    return urlObj.origin !== window.location.origin;
  } catch {
    // If URL parsing fails, treat as internal
    return false;
  }
};

/**
 * Validates if a URL is safe to navigate to
 */
export const isSafeUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url, window.location.origin);
    const allowedProtocols = ["http:", "https:", "mailto:", "tel:"];
    return allowedProtocols.includes(urlObj.protocol);
  } catch {
    return false;
  }
};

/**
 * Sanitizes a URL for safe use
 */
export const sanitizeUrl = (url: string): string => {
  if (!isSafeUrl(url)) {
    console.warn(`Potentially unsafe URL blocked: ${url}`);
    return "#";
  }
  return url;
};
